/**
 * Column definitions for the Manual Reporting (Binary Demand) CSV format.
 * Header names are the canonical Title Case, space-separated columns (e.g.
 * `Impression Date`), matching `report_upload_template.csv`. Header matching is
 * tolerant (see `toManualReportingColumnKey` below), but the stored file always
 * uses these canonical names. Validation rules live in `ManualReportingValidator`;
 * this file is the single source of truth for the expected columns + their kind.
 */
export const ManualReportingColumn = {
    country: 'Country',
    companyDomain: 'Company Domain',
    impressions: 'Impressions',
    clicks: 'Clicks',
    impressionDate: 'Impression Date',
    clickDate: 'Click Date',
};
export const ManualReportingColumnValidation = {
    [ManualReportingColumn.country]: { required: true, kind: 'country' },
    [ManualReportingColumn.companyDomain]: { required: true, kind: 'domain' },
    [ManualReportingColumn.impressions]: { required: true, kind: 'number' },
    [ManualReportingColumn.clicks]: { required: true, kind: 'number' },
    [ManualReportingColumn.impressionDate]: { required: true, kind: 'date' },
    // Optional: the column may be omitted entirely and, when present, left blank.
    [ManualReportingColumn.clickDate]: { required: false, kind: 'date' },
};
export const ManualReportingColumnValidationEntries = Object.entries(ManualReportingColumnValidation);
export const ManualReportingColumns = ManualReportingColumnValidationEntries.map(([columnName]) => columnName);
export const ManualReportingColumnsString = ManualReportingColumns.join(',');
/**
 * Normalized header key for tolerant matching: trims, lowercases, and treats
 * underscores and runs of whitespace as a single space. So `Impression_Date`,
 * `Impression Date`, and `impression  date` all map to the same key — real DSP
 * exports (which use underscores) validate against our template names.
 */
export const toManualReportingColumnKey = (header) => header
    .trim()
    .toLocaleLowerCase()
    .replace(/[\s_]+/g, ' ');
//# sourceMappingURL=manualReportingColumns.js.map